import * as React from "react";
import { useUser } from "./AccountStore";
import { Campaign, GetCampaign, GetQuestionnaire } from "./ServiceManagerAPI";

export function useCampaign() {
    const { user } = useUser();

    const [registrationCampaignID, setRegistrationCampaignID] = React.useState("");
    const [registrationCampaign, setRegistrationCampaign] = React.useState({} as Campaign);

    const [learningCampaignID, setLearningCampaignID] = React.useState("");
    const [learningCampaign, setLearningCampaign] = React.useState({} as Campaign);

    const [learningStep2CampaignID, setLearningStep2CampaignID] = React.useState("");
    const [learningStep2Campaign, setLearningStep2Campaign] = React.useState({} as Campaign);

    const [submissionCampaignID, setSubmissionCampaignID] = React.useState("");
    const [submissionCampaign, setSubmissionCampaign] = React.useState({} as Campaign);

    React.useEffect(() => {
        if (user.isAuthenticated) {
            setRegistrationCampaignID(RegistrationCampaignID);
            setLearningCampaignID(LearningCampaignID);
            setLearningStep2CampaignID(LearningStep2CampaignID);
            setSubmissionCampaignID(SubmissionsCampaignID);
        }
    }, [user]);

    React.useEffect(() => {
        if (registrationCampaignID && !registrationCampaign.id) {
            GetCampaign(registrationCampaignID).then((res) => {
                setRegistrationCampaign(res.data.result);
            });
        }

        if (learningCampaignID && !learningCampaign.id) {
            GetCampaign(learningCampaignID).then((res) => {
                setLearningCampaign(res.data.result);
            });
        }

        if (learningStep2CampaignID && !learningStep2Campaign.id) {
            GetCampaign(learningStep2CampaignID).then((res) => {
                setLearningStep2Campaign(res.data.result);
            });
        }

        if (submissionCampaignID && !submissionCampaign.id) {
            GetCampaign(submissionCampaignID).then((res) => {
                setSubmissionCampaign(res.data.result);
            });
        }
    }, [registrationCampaignID, learningCampaignID, learningStep2CampaignID, submissionCampaignID]);

    return { registrationCampaign, learningCampaign, learningStep2Campaign, submissionCampaign };
}

export function useQuestionnaire(id) {
    const { user } = useUser();

    const [questionnaire, setQuestionnaire] = React.useState({} as { id: string; questions: any[]; timestamp: string });

    React.useEffect(() => {
        if (user.isAuthenticated) {
            GetQuestionnaire(id).then((res) => {
                setQuestionnaire(res.questionnaire);
            });
        }
    }, [user, id]);

    return questionnaire;
}

// let [submissions, setSubmissions] = React.useState([]);
// let [activeCampaign, setActiveCampaign] = React.useState({} as Campaign);
// let [covidApps, setCovidApps] = React.useState([]);
// let [loading, setLoading] = React.useState(true);

// React.useEffect(() => {
//     if (activeCampaign.id) {
//         axios.get(`https://localhost:44304/api/Campaigns/${activeCampaign.id}/$submissions`).then((res) => {
//             setSubmissions(res.data.result);
//         });
//     }
// }, [activeCampaign]);
